import React, { useState } from "react";
import {
  Button,
  FlexRowBetween,
  Input,
  Label,
  PopupForm,
} from "../common/Style";
import { useForm } from "react-hook-form";
import { CFV } from "../common/others/Functions";
import OpacityLoading from "../common/loader/OpacityLoading";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { add } from "../../store/reducers/userReducer";
import GCalendar from "../common/calendar/Calendar";
import GenericModal from "../common/modals/GenericModal";
import FilterBar from "../common/others/FilterBar";

const AddUser = ({ init }) => {
  const dispatch = useDispatch();
  const { usersLoading } = useSelector((state) => state.userReducer);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [showCalendar, setShowCalendar] = useState(null);

  let categories = [
    { id: "חתונה", name: "חתונה" },
    { id: "אחר", name: "אחר" },
  ];
  const [category, setCategory] = useState("חתונה");
  const [date, setDate] = useState(new Date());

  const handleSetDate = (e) => {
    let date1 = e;
    date1.setHours(20);
    setDate(date1);
  };

  const onSubmit = async (data) => {
    const body = {
      ...data,
      date: date.toISOString(),
      eventid: "besimple",
      eventType: category == "חתונה" ? true : false,
    };
    dispatch(add(body)).then((res) => {
      if (!res.payload?.error) {
        toast.success("הפעולה בוצעה בהצלחה");
        init();
      } else toast.error(res.payload?.error);
    });
  };

  return (
    <PopupForm
      onClick={(e) => e.stopPropagation()}
      onSubmit={handleSubmit(onSubmit)}
      className="animate__animated animate__fadeIn"
    >
      <div
        style={{
          width: "90%",
          margin: "15px auto",
        }}
      >
        <Label>מס׳ נייד</Label>
        <Input
          {...register("phone", {
            required: true,
            pattern: /^[0]{1}[5]{1}[0-9]{8}$/,
          })}
        />
        {CFV("phone", "פורמט מספר פלאפון לא חוקי", errors)}

        <Label>תאריך</Label>
        <Input
          onClick={() => setShowCalendar(true)}
          value={date
            .toISOString()
            .replace(/T.*/, "")
            .split("-")
            .reverse()
            .join("/")}
          onChange={() => {}}
          type={"text"}
        />
        <div style={{ height: "30px" }} />
        <FilterBar
          //   color={"rgba(82, 18, 165, 0.475)"}
          padding={"7px 12px"}
          data={categories}
          setProperty={setCategory}
          property={category}
        />

        <FlexRowBetween style={{ marginTop: "50px" }}>
          <Button style={{ width: "100%" }}>הוספה</Button>
        </FlexRowBetween>
      </div>

      {usersLoading && <OpacityLoading />}

      {showCalendar && (
        <GenericModal
          init={setShowCalendar}
          div={
            <GCalendar
              setDate={handleSetDate}
              date={date}
              init={setShowCalendar}
            />
          }
        />
      )}
    </PopupForm>
  );
};

export default AddUser;
